import React from "react";
import "../../../groups/Groups.css";
import PaginationTable from "../../../../components/paginationTable/PaginationTable";
import { textFilter } from "react-bootstrap-table2-filter";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import Button from "react-bootstrap/Button";
import UnsavedChangesDialog from "../../../../components/dialogs/unsavedChangesDialog/UnsavedChangesDialog";
import StorageService from "../../../../services/StorageService";
import APIErrorHelper from "../../../../helpers/APIErrorHelper";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import DeleteDialog from "../../../../components/dialogs/deleteDialog/DeleteDialog";
import DepartmentActionCell from "./departmentsActionCell/DepartmentActionCell";
import CreateDepartmentDialog from "./dialogs/createDepartmentDialog/CreateDepartmentDialog";
import UpdateDepartmentDialog from "./dialogs/updateDepartmentDialog/UpdateDepartmentDialog";
import PaginationTableFilterToggle from "../../../../components/paginationTableFilterToggle/PaginationTableFilterToggle";

class DepartmentsTab extends React.Component {
  tableId = "departmentsTable";

  constructor(props) {
    super(props);
    let showFilters = StorageService.tableConfigShowFilters(this.tableId);
    this.state = {
      departments: [],
      showCreateClassModal: false,
      showDeleteSingleDepartmentModal: false,
      showUpdateDepartmentModal: false,
      showMembersModal: false,
      showUnsavedChangesDialog: false,
      closeAction: () => {},
      departmentToDeleteOrEdit: null,
      displayFilter: showFilters ? "initial" : "none",
      showFilters,
      dialogApiError: "",
      apiError: "",
      isDeleting: false,
      isUpdating: false,
    };

    this.handleCreateDepartment = this.handleCreateDepartment.bind(this);
    this.handleUpdateDepartment = this.handleUpdateDepartment.bind(this);
    this.handleDeleteDepartment = this.handleDeleteDepartment.bind(this);
    this.handleOnDelete = this.handleOnDelete.bind(this);
  }

  async componentDidMount() {
    this.paginationTableRef = React.createRef();

    try {
      let departments = StorageService.getReferenceType("departments");

      if (departments) {
        this.setState({ departments: departments });
        this.props.departmentCallback(departments);
      }
      departments = await CamplaCoreService.getAllDepartments();
      StorageService.set("departments", departments);
      this.setState({ departments });
      this.props.departmentCallback(departments);
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ apiError: "" });
          },
          {},
          this.props.t,
        ),
      });
    }
  }

  async handleCreateDepartment(departmentToCreate) {
    try {
      const createdDepartment = await CamplaCoreService.createDepartment(
        departmentToCreate,
      );
      this.state.departments.push(createdDepartment);

      this.setState({
        showCreateClassModal: false,
        departments: Object.assign([], this.state.departments),
      });
      this.props.departmentCallback(this.state.departments);
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ dialogApiError: "" });
          },
          {
            PRECONDITION_FAILED: "Organisation.APIError.PreconditionFailed",
          },
          this.props.t,
        ),
      });
    }
  }

  async handleUpdateDepartment(changedDepartment) {
    try {
      this.setState({ isUpdating: true });

      const updatedDepartment = await CamplaCoreService.updateDepartment(
        this.state.departmentToDeleteOrEdit._id,
        changedDepartment,
      );

      let index = this.state.departments
        .map((c) => c._id)
        .indexOf(this.state.departmentToDeleteOrEdit._id);
      if (index !== -1) {
        this.state.departments[index] = updatedDepartment;
      }
      this.setState({
        showUpdateDepartmentModal: false,
        departments: Object.assign([], this.state.departments),
        departmentToDeleteOrEdit: null,
        isUpdating: false,
      });
      this.props.departmentCallback(this.state.departments);
    } catch (err) {
      this.setState({
        isUpdating: false,
        dialogApiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ dialogApiError: "" });
          },
          {
            PRECONDITION_FAILED: "Organisation.APIError.PreconditionFailed",
            NOT_FOUND: "Organisation.APIError.NotFound",
            CONFLICT: "Organisation.APIError.DeleteConflict",
          },
          this.props.t,
        ),
      });
    }
  }

  handleOnDelete(sClass) {
    this.setState({
      departmentToDeleteOrEdit: sClass,
      showDeleteSingleDepartmentModal: true,
    });
  }

  async handleDeleteDepartment() {
    this.setState({ isDeleting: true });

    try {
      await CamplaCoreService.deleteDepartment(
        this.state.departmentToDeleteOrEdit._id,
      );

      const index = this.state.departments.findIndex(
        (obj) => obj._id === this.state.departmentToDeleteOrEdit._id,
      );
      if (index !== -1) {
        const newDepartments = this.state.departments.filter(
          (obj) => obj._id !== this.state.departmentToDeleteOrEdit._id,
        );
        this.setState(
          {
            departments: newDepartments,
            showDeleteSingleDepartmentModal: false,
            departmentToDeleteOrEdit: null,
            isDeleting: false,
          },
          () => {},
        );
        this.props.departmentCallback(this.state.departments);
      }
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ dialogApiError: "" });
          },
          {
            PRECONDITION_FAILED: "Organisation.APIError.PreconditionFailed",
            NOT_FOUND: "Organisation.APIError.NotFound",
            CONFLICT: "Organisation.APIError.DeleteConflict",
          },
          this.props.t,
        ),
        isDeleting: false,
      });
    }
  }

  getLanguage(cell) {
    const i18n = this.props.i18n;
    const usedLang = (i18n.resolvedLanguage || i18n.language || "en").split(
      "-",
    )[0];
    const filteredLangs = Object.entries(cell)
      .filter(([lang, value]) => value !== "")
      .map(([lang]) => lang);
    const finalLang = filteredLangs.includes(usedLang)
      ? usedLang
      : filteredLangs[0];
    return cell[finalLang];
  }

  render() {
    const { t } = this.props;

    const memberData = {
      count: Date.now(),
    };

    const columns = [
      {
        dataField: "identifier",
        text: t("Organisation.DepartmentTabbar.ActionCell.ColumnName"),
        sort: true,
        filter: textFilter({
          placeholder: t(
            "Organisation.DepartmentTabbar.ActionCell.FilterNamePlaceholder",
          ),
          style: { width: "auto", display: this.state.displayFilter },
        }),
      },
      {
        dataField: "description",
        text: t("Organisation.DepartmentTabbar.ActionCell.ColumnDescription"),
        formatExtraData: memberData,
        filter: textFilter({
          placeholder: t(
            "Organisation.DepartmentTabbar.ActionCell.FilterDescriptionPlaceholder",
          ),
          style: { width: "auto", display: this.state.displayFilter },
        }),
        sort: true,
        formatter: (cell, row) => this.getLanguage(cell, row),
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
          <PaginationTableFilterToggle
            onFilterToggle={(e) => {
              this.setState({
                showFilters: e.currentTarget.checked,
                displayFilter: e.currentTarget.checked ? "initial" : "none",
              });
            }}
            showFilters={this.state.showFilters}
            tableId={this.tableId}
          />
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatter: (cell, sClass) => (
          <DepartmentActionCell
            onEdit={() => {
              this.setState({
                showUpdateDepartmentModal: true,
                departmentToDeleteOrEdit: sClass,
              });
            }}
            onDelete={() => this.handleOnDelete(sClass)}
            class={sClass}
          />
        ),
      },
    ];

    return (
      <div>
        <CreateDepartmentDialog
          show={this.state.showCreateClassModal}
          dialogApiError={this.state.dialogApiError}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                showUnsavedChangesDialog: true,
                closeAction: () =>
                  this.setState({
                    dialogApiError: null,
                    showCreateClassModal: false,
                  }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showCreateClassModal: false,
              });
            }
          }}
          onSubmit={this.handleCreateDepartment}
        />

        <DeleteDialog
          show={this.state.showDeleteSingleDepartmentModal}
          dialogApiError={this.state.dialogApiError}
          onHide={() =>
            this.setState({
              dialogApiError: null,
              showDeleteSingleDepartmentModal: false,
            })
          }
          onSubmit={this.handleDeleteDepartment}
          title={t("Organisation.DepartmentTabbar.DeleteDialog.Title")}
          body={
            <div style={this.state.isDeleting ? { textAlign: "center" } : {}}>
              {this.state.isDeleting ? (
                <Spinner animation="border" />
              ) : (
                t("Organisation.DepartmentTabbar.DeleteDialog.Text", {
                  className: this.state.departmentToDeleteOrEdit?.identifier,
                })
              )}
            </div>
          }
          rightButtonText={t("Groups.GroupModal.DeleteModal.Submit")}
          leftButtonText={t("Groups.GroupModal.DeleteModal.Cancel")}
        />

        <UpdateDepartmentDialog
          isUpdating={this.state.isUpdating}
          show={this.state.showUpdateDepartmentModal}
          dialogApiError={this.state.dialogApiError}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                dialogApiError: null,
                showUnsavedChangesDialog: true,
                closeAction: () =>
                  this.setState({
                    showUpdateDepartmentModal: false,
                  }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showUpdateDepartmentModal: false,
              });
            }
          }}
          onSubmit={this.handleUpdateDepartment}
          class={this.state.departmentToDeleteOrEdit}
        />
        <UnsavedChangesDialog
          show={this.state.showUnsavedChangesDialog}
          onHide={() => this.setState({ showUnsavedChangesDialog: false })}
          onSubmit={() => {
            this.setState({ showUnsavedChangesDialog: false });
            this.state.closeAction();
          }}
        />
        <Container className="mt-3 pl-0 pr-0">
          <Row className="pageTitle">
            <Col>
              <h4>{t("Organisation.OrganisationTabbar.DepartmentsTitle")}</h4>
            </Col>
            <Col>
              <div style={{ float: "right" }}>
                <Button
                  className="btn-green ml-3"
                  onClick={() => {
                    this.setState({ showCreateClassModal: true });
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </Button>
              </div>
            </Col>
          </Row>
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row>
            <Col>
              <p>
                {t("Organisation.DepartmentTabbar.Description")}
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <PaginationTable
                data={this.state.departments}
                sizePerPage={10}
                paginationSize={3}
                columns={columns}
                keyField="_id"
                ref={this.paginationTableRef}
                id={this.tableId}
                formatExtraData={memberData}
                view="departments"
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(DepartmentsTab);
